import React from "react";
import { Container } from "react-bootstrap";
import '../components/Clients/Client.css';

// Assuming your images are in src/assets/
import ClientLogo1 from "../assets/ClientsLogo/image 1.png";
import ClientLogo2 from "../assets/ClientsLogo/image 10.png";
import ClientLogo3 from "../assets/ClientsLogo/image 2.png";
import ClientLogo4 from "../assets/ClientsLogo/image 3.png";
import ClientLogo5 from "../assets/ClientsLogo/image 4.png";
import ClientLogo6 from "../assets/ClientsLogo/image 5.png";
import ClientLogo7 from "../assets/ClientsLogo/image 6.png";
import ClientLogo8 from "../assets/ClientsLogo/image 8.png";
import ClientLogo9 from "../assets/ClientsLogo/image 9.png";
import ClientLogo10 from "../assets/ClientsLogo/image 7.png";

const clientLogos = [
  { name: "Tata Ficosa", img: ClientLogo1 },
  { name: "Joyson", img: ClientLogo2 },
  { name: "Seco Komos", img: ClientLogo3 },
  { name: "Magna", img: ClientLogo4 },
  { name: "Endurance", img: ClientLogo5 },
  { name: "Noble", img: ClientLogo6 },
  { name: "BorgWarner", img: ClientLogo7 },
  { name: "DAS", img: ClientLogo8 },
  { name: "Motherson", img: ClientLogo9 },
  { name: "Yanfeng", img: ClientLogo10 },
];

export default function ClientsSection() {
  return (
    <section className="clients-section py-5">
      <Container className="my-5">
        <div className="text-center mb-5">
          <h2 className="section-title">Trusted By Industry Leaders</h2>
        </div>

        <div className="clients-grid">
          {clientLogos.map((logo, index) => (
            <div key={index} className="client-logo-wrapper">
              <div className="client-logo-card">
                <img
                  src={logo.img}
                  alt={logo.name}
                  className="client-img"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}